import React from 'react';

type LinkArrowIconProps = {
  color?: string;
  width?: number;
  height?: number;
};

export const LinkArrowIcon: React.FC<LinkArrowIconProps> = ({
  color = '#A188FD',
  width = 44,
  height = 81,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 44 81"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.333333 3C0.333333 4.47276 1.52724 5.66667 3 5.66667C4.47276 5.66667 5.66667 4.47276 5.66667 3C5.66667 1.52724 4.47276 0.333333 3 0.333333C1.52724 0.333333 0.333333 1.52724 0.333333 3ZM43.5 77.5L38.5 74.6133V80.3867L43.5 77.5ZM3 3H2.5V69.5H3H3.5V3H3ZM11 77.5V78H39V77.5V77H11V77.5ZM3 69.5H2.5C2.5 74.1944 6.30558 78 11 78V77.5V77C6.85786 77 3.5 73.6421 3.5 69.5H3Z"
      fill={color}
    />
  </svg>
);
